import { fetch } from '@/plugin/axios/index.js'

/**
 * @param {Object} data
 * 获取故障模板列表
 */
export function getPointTemplateList(data) {
  return fetch ({
    url: '/repair/repair/pointTemplate/pageList',
    method: 'POST',
    data
  })
}


/**
 * @param {Object} data
 * 保存故障模板
 */
export function savePointTemplate(data) {
  return fetch({
    url: '/repair/repair/pointTemplate/save',
    method: 'POST',
    data
  })
}copyPointTemplate


/**
 * @param {Object} data
 *  复制故障模板
 */
export function copyPointTemplate(data) {
  return fetch({
    url: '/repair/repair/pointTemplate/copyTemplate',
    method: 'POST',
    data
  })
}


/**
 * @param {Object} data
 * 删除故障模板
 */
export function deleteTemplate(data) {
  return fetch({
    url: '/repair/repair/pointTemplate/delete',
    method: 'POST',
    data
  })
}


// WEBPACK FOOTER //
// ./src/api/FaultTypesTemplate/index.js